import { useTranslation } from 'react-i18next';
import { createFileRoute } from '@tanstack/react-router';
import { FEATURE_FLAGS, useFeatureFlag } from '@/hooks/useFeatureFlag';
import { TrialLockedPanel } from '@/sections/white-glove/trial-locked-panel';
import { DashboardSectionsListView } from '@/sections/dashboard/sections/dashboard-sections-list';

export const Route = createFileRoute('/_authed/dashboard/o/$orgId/c/$clientId/sections/')({
  component: SectionsPage,
});

/**
 * The section library, which is a builder surface.
 *
 * Sections are the pieces you assemble an email out of yourself, so they belong
 * to the self-serve product rather than to a brand whose emails somebody else
 * assembles. There is no launch flag of their own here -- the DIY gate is the
 * whole question.
 */
function SectionsPage() {
  const { t } = useTranslation('common');
  const selfServe = useFeatureFlag(FEATURE_FLAGS.SELF_SERVE_BUILDER);

  if (!selfServe) {
    return (
      <TrialLockedPanel
        title={t('nav.sections', 'Sections')}
        body={t(
          'sections.locked',
          'Sections are the building blocks you assemble an email from yourself.'
        )}
      />
    );
  }

  return <DashboardSectionsListView />;
}
